import React, { FC, SVGProps } from "react"

import { useTheme } from "@emotion/react"

export const IconCheck: FC<SVGProps<SVGSVGElement>> = props => {
  const theme = useTheme()
  return (
    <svg
      fill="none"
      height="1em"
      viewBox="0 0 20 20"
      width="1em"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <title lang="en">Check</title>
      <path
        d="M16.667 5 7.5 14.167 3.333 10"
        stroke={theme.colors.primaryMedium}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
      />
    </svg>
  )
}
